import { render, staticRenderFns } from "./WorkersStatisticsPage.vue?vue&type=template&id=ad529c06&"
import script from "./WorkersStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./WorkersStatisticsPage.vue?vue&type=script&lang=js&"
import style0 from "./WorkersStatisticsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VDatePicker,VFlex,VLayout,VMenu,VSelect,VTextField})
